import SearchIcon from '@mui/icons-material/Search';
import {
  Divider,
  InputAdornment,
  MenuItem,
  Select,
  type SxProps,
  TextField,
  type Theme,
} from '@mui/material';
import {
  SEARCH_SCOPE_OPTIONS,
  type SearchScope,
} from '../CatalogFilterModel/catalogSearchScope';

interface CatalogSearchFieldProps {
  scope: SearchScope;
  onScopeChange: (scope: SearchScope) => void;
  query: string;
  onQueryChange: (query: string) => void;
  /** Merged onto the underlying TextField (e.g. to constrain its height). */
  sx?: SxProps<Theme>;
}

/**
 * Catalog search input with a scope selector attached to its left edge. The
 * scope narrows the query to one field; search stays live/debounced upstream,
 * so the magnifying glass is decorative (no submit).
 */
export const CatalogSearchField = ({
  scope,
  onScopeChange,
  query,
  onQueryChange,
  sx,
}: CatalogSearchFieldProps) => (
  <TextField
    fullWidth
    sx={sx}
    placeholder="Search Catalog…"
    value={query}
    onChange={(e) => onQueryChange(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Select
            variant="standard"
            disableUnderline
            value={scope}
            onChange={(e) => onScopeChange(e.target.value as SearchScope)}
            sx={{ minWidth: 120, mr: 1, '& .MuiSelect-select': { py: 0 } }}
            data-qa-id="catalog-search-scope"
          >
            {SEARCH_SCOPE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <Divider orientation="vertical" flexItem sx={{ mr: 1 }} />
          <SearchIcon />
        </InputAdornment>
      ),
    }}
  />
);
